import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect }    from 'react-redux';
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link,
  Tooltip,
  OverlayTrigger,
  Checkbox,
  Radio,
  ButtonGroup,
  DropdownButton,
  MenuItem
}                     from 'react-bootstrap';
import { withRouter } from 'react-router';
import {
  bindActionCreators,
  compose
}                     from 'redux';

import DateTimePicker from 'react-datetime-picker';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import moment from 'moment';

import {
  Breadcrumb as BreadcrumbComponent
}                        from '../../../../components';
import Pagination from 'react-paginating';
import { getCoutnryCity, getSubscriberFile, getTotalSubscriber } from '../../../../redux/actions/emailManagerActions';
import { get_merchant_list } from '../../../../redux/actions/merchantActions';
import { getAllCategory } from '../../../../redux/actions/dealActions';

import CKEditor from "react-ckeditor-component";
let rand = require("random-key");

let cityID = [], subscriberList=[];
let isLoading="false";
class WizardFormSecondPage extends Component {
  constructor(props){
    super(props);
    this.state = {
      startDateValue : (this.props.data.startDateValue) ? this.props.data.startDateValue : '',
      startDateRange : (this.props.data.startDateRange) ? this.props.data.startDateRange : '',
      startDateRangeStatus : (!this.props.data.startDateRangeStatus) ? true : false,
      categoryStatus: (this.props.data.categoryStatus) ? true :false,
      merchantStatus: (this.props.data.merchantStatus) ? true :false,
      merchantID: (this.props.data.merchantID) ? this.props.data.merchantID : '',
      catID: (this.props.data.catID) ? this.props.data.catID : '',
      cityList: (this.props.data.cityList) ? this.props.data.cityList : '',
      cityID: (this.props.data.cityID) ? this.props.data.cityID : [],
      scheduleStatus: (this.props.data.scheduleStatus) ? true :false,
      scheduleDateTime: (this.props.data.scheduleDateTime) ? this.props.data.scheduleDateTime : '',
      purchases: (this.props.data.purchases) ? this.props.data.purchases : '',
      cityError: (this.props.data.cityError) ? true :false,
      dateError: (this.props.data.dateError) ? true :false,
      purchaseError: (this.props.data.purchaseError) ? true :false,
      scheduleError: (this.props.data.scheduleError) ? true :false,
      merchantList: '',
      merchantIDError: '',
      fileList: (this.props.data.fileList) ? this.props.data.fileList : '',
      catIDError: '',
      catList: '',
      totalRecords: '',
      perPage: '',
      pageCount: '',
      subscriberList: (this.props.data.subscriberList) ? this.props.data.subscriberList : [],
      user: 0,
      subscriber: 0,
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handlePrev = this.handlePrev.bind(this);
  }

  handlePageChange = page => {
    isLoading="true";
    this.setState({
      currentPage: page
    });
    this.props.getSubscriberFile({page:page,limit: this.state.limit, site_id: localStorage.getItem("siteID")});
    // this.props.getSiteCity();
  };

  componentWillMount(){
    this.props.getCoutnryCity({site_id: localStorage.getItem("siteID")});
    this.props.get_merchant_list({page:0, site_id: localStorage.getItem("siteID")});
    this.props.getAllCategory({ page: 0, site_id: localStorage.getItem("siteID") });
    this.handlePageChange();
    if(this.state.cityID == ''){
      cityID = [];
    }
  }

  componentWillReceiveProps(nextProps){

    if(this.state.cityID == ''){
      cityID = [];
    }

    if(this.state.subscriberList == ''){
      subscriberList = [];
    }
    
    if(this.props.cityList !== nextProps.cityList){
        if(nextProps.cityList){
          this.setState({cityList: nextProps.cityList.data});
        }
    } 

    if(this.props.merchantList !== nextProps.merchantList){
        if(nextProps.merchantList){
          this.setState({merchantList:nextProps.merchantList});
        }
    }

    if(this.props.catList !== nextProps.catList){
        if(nextProps.catList){
            this.setState({catList:nextProps.catList.data.data})

        }
    }

    if(this.props.subscriberList !== nextProps.subscriberList){
      if(nextProps.subscriberList){
        isLoading="false";
        const setPageCount = nextProps.subscriberList.data.total / nextProps.subscriberList.data.per_page;
        this.setState({fileList: nextProps.subscriberList.data, totalRecords:nextProps.subscriberList.data.total, perPage:nextProps.subscriberList.data.per_page, pageCount:setPageCount})
      }
    }

    if(this.props.totalUsers !== nextProps.totalUsers){
      if(nextProps.totalUsers){
        this.setState({user: nextProps.totalUsers.data.user, subscriber: nextProps.totalUsers.data.subscriber})
      }
    }

  }

  handlePurchaseBy = (e) => {
    if(e.target.value == 'all' || e.target.value == 'not_purchase'){
      this.setState({merchantStatus : false, merchantID: '', catID: '', categoryStatus : false})
    }
    this.setState({purchaseError: false});
    this.setState({[e.target.name] : e.target.value})
  }

  onChangeStartDateRange = date => {
    this.setState({ startDateRange: date});
    this.setState({dateError: false});
  }

  handleCityData = (e) => {
    cityID = (this.state.cityID) ? this.state.cityID : [];
    let index;

    if (e.target.checked) {
      cityID.push(e.target.value);
    } else {
      index = cityID.indexOf(e.target.value)
      cityID.splice(index, 1)
    }
    this.setState({cityError: false});
    this.setState({cityID : cityID});
  }

  handleSelectedFile = (e) => {
    subscriberList = (this.state.subscriberList) ? this.state.subscriberList : [];
    let index;
    if (e.target.checked) {
      subscriberList.push(e.target.value);
    } else {
      index = subscriberList.indexOf(e.target.value)
      subscriberList.splice(index, 1)
    }
    // this.setState({subscriberList : subscriberList});
  }

  handSubscriptionDate = (e) => {
     if (e.target.checked) {
      this.setState({startDateRangeStatus : false, startDateValue: 'all'})
     } else {
      this.setState({startDateRangeStatus : true, startDateValue: ''})
     }
     this.setState({dateError: false});
  }

  handleChangeMerchantID = (e) => {
    this.setState({merchantIDError:''})
    let options = e.target.options;
    let value = [];
    for (let i = 0, l = options.length; i < l; i++) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    }
    this.setState({merchantID: value});
  }

  handleChangeCatID = (e) => {
    this.setState({catIDError:''})
    let options = e.target.options;
    let value = [];
    for (let i = 0, l = options.length; i < l; i++) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    }
    this.setState({catID: value});
  }

  validate = (e) => {
    let isError = false;
    if(this.state.cityID.length == 0){
      isError = true;
      this.setState({cityError: true});
    }else{
      this.setState({cityError: false});
    }

    if(this.state.startDateRange == '' && this.state.startDateValue == ''){
      isError = true;
      this.setState({dateError: true});
    }else{
      this.setState({dateError: false});
    }

    if(this.state.purchases == ''){
      isError = true;
      this.setState({purchaseError: true});
    }else{
      this.setState({purchaseError: false});
    }

    if(this.state.purchases == 'merchant' && this.state.merchantID == ''){
      isError = true;
      this.setState({merchantIDError: 'red'});
    }

    if(this.state.purchases == 'category' && this.state.catID == ''){
      isError = true;
      this.setState({catIDError: 'red'});
    }

    if(this.state.scheduleStatus == true && this.state.scheduleDateTime == ''){
      isError = true;
      this.setState({scheduleError: true});
    }else{
      this.setState({scheduleError: false});
    }

    return isError;
  }

  handleSubmit = (e) => {
    e.preventDefault();
    let isError = this.validate();
    if(!isError){
      this.props.onSave(this.state)
    }
    
    // this.props.onSubmit();
  }

  handlePrev = (e) => {
    e.preventDefault();
    this.props.previousPage();
    this.props.onPrevData(this.state)
  }

  editCategory = (e) => {
    this.setState({merchantStatus: false, categoryStatus: true});
  }

  editMerchant = (e) => {
    this.setState({merchantStatus: true, categoryStatus: false});
  }

  onChangeScheduleDateTime = (date) => {
    this.setState({ scheduleDateTime: date })
    this.setState({scheduleError: false});
  }

  handleSchedule = (e) => {
    this.setState({scheduleStatus: true});
  }

  cancelSchedule = (e) => {
    this.setState({scheduleStatus: false, scheduleDateTime: ''});
  }

  handleTotalUser = (e) => {
    let dateRange = (this.state.startDateRange) ? this.state.startDateRange : '';
    const filterData = {
      cities: this.state.cityID,
      subscriberType: (this.state.startDateValue == 'all') ? 'all' : 'NotAll',
      subscriberStartDate: dateRange[0],
      subscriberEndDate: dateRange[1],
      filterPurchase: (this.state.purchases == 'category' || this.state.purchases == 'merchant'  || this.state.purchases ==  'not_purchase') ? 'NotAll' : this.state.purchases,
      catID: this.state.catID,
      merchantID: this.state.merchantID,
      site_id: localStorage.getItem("siteID")
    }

    this.props.getTotalSubscriber(filterData);
  }

  render() {
    const { currentPage,totalRecords,perPage,pageCount } = this.state;
    if(this.props.data.cityID){
      cityID = this.props.data.cityID;
    }

    if(this.props.data.subscriberList){
      subscriberList = this.props.data.subscriberList;
    }

  return (
    <form>
      <div className="panel">
          <header className="panel-heading">Target Users</header>
          <div className="panel-body">
          <Row>
              <Col md={12} xs={12}>
                <FormGroup>
                  <ControlLabel>Subscribers in the following Cities: <span className="text-danger">{(this.state.cityError) ? '(Please select city.)' : ''}</span></ControlLabel>
                  {(this.state.cityList) &&
                    this.state.cityList.map((data, index) =>
                      <Row>
                      <Col md={12} xs={12}><b>{(data.cities.length != 0) ? data.country : ''}</b></Col>
                        <Col md={12} xs={12}>
                          <Row>
                          {data.cities.map((cityData, index) => 

                              <Col md={4} xs={12}>
                                {(cityID.indexOf(JSON.stringify(cityData.cityID)) > -1) ?
                                // <div>check</div>
                                <Checkbox onClick={this.handleCityData} defaultChecked={true} value={cityData.cityID}>{cityData.title}</Checkbox>
                                :
                                <Checkbox onClick={this.handleCityData}  value={cityData.cityID}>{cityData.title}</Checkbox>
                                }
                              </Col>
                            )
                          }
                          </Row>
                        </Col>
                      </Row>
                    )
                  }
                </FormGroup>
              </Col>
              <Col md={12} xs={12}>
                <FormGroup>
                  <ControlLabel>Subscription Date: <span className="text-danger">{(this.state.dateError) ? '(Please select date option.)' : ''}</span></ControlLabel>
                  <Checkbox name="dates" defaultChecked={this.state.startDateValue} onClick={this.handSubscriptionDate}>
                    All Dates
                  </Checkbox>
                  {(this.state.startDateRangeStatus) &&
                  <DateRangePicker
                    onChange={this.onChangeStartDateRange}
                    value={this.state.startDateRange}
                  />
                  }
                </FormGroup>
              </Col>
              <Col md={12} xs={12}>
                <FormGroup>
                  <ControlLabel>Filter by purchases: <span className="text-danger">{(this.state.purchaseError) ? '(Please select purchase filter option.)' : ''}</span></ControlLabel>
                  <Radio name="purchases" defaultChecked={(this.state.purchases == 'all') ? true : ''} onClick={this.handlePurchaseBy} value="all">
                    All
                  </Radio>
                  <Radio name="purchases" defaultChecked={(this.state.purchases == 'category') ? true : ''} onClick={this.handlePurchaseBy} value="category">
                    User who purchase in: Any Category <a onClick={this.editCategory}>Edit Category</a>
                  </Radio>
                  {(this.state.categoryStatus) &&
                  <FormControl componentClass="select" value={this.state.catID} multiple style={{borderColor:this.state.catIDError}} name="catID" onChange={this.handleChangeCatID} placeholder="select">
                    <option value="">Select Category</option>
                    {(this.state.catList.length != 0) &&
                      this.state.catList.map((el, keyValue) => {
                          return <option key={keyValue} value={el.catID}>{el.catName}</option>;
                    })}
                  </FormControl>
                  }
                  <Radio name="purchases"  onClick={this.handlePurchaseBy} defaultChecked={(this.state.purchases == 'merchant') ? true : ''} value="merchant">
                    User who purchase in: Any Merchants <a onClick={this.editMerchant}>Select Merchant</a>
                  </Radio>
                  {(this.state.merchantStatus) &&
                  <FormControl componentClass="select" value={this.state.merchantID} multiple style={{borderColor:this.state.merchantIDError}} name="merchantID" onChange={this.handleChangeMerchantID} placeholder="select">
                    <option value="">Select Merchant</option>
                    {(this.state.merchantList.length != 0) &&
                      this.state.merchantList.map((el, key) => {
                          return <option key={key} value={el.merchantID}>{el.merchantName}</option>;
                    })}
                  </FormControl>
                  }
                  <Radio name="purchases" defaultChecked={(this.state.purchases == 'not_purchase') ? true : ''} onClick={this.handlePurchaseBy} value="not_purchase">
                    Users who did not purchase
                  </Radio>
                  <Radio name="purchases" defaultChecked={(this.state.purchases == '0') ? true : ''} onClick={this.handlePurchaseBy} value="0">
                    Do Not Email Users
                  </Radio>
                </FormGroup>
              </Col>
          </Row>
          {(this.state.scheduleStatus) &&
            <Row>
              <Col md={12} xs={12}>
              <FormGroup>
                  <ControlLabel>Select Schedule Time: <span className="text-danger">{(this.state.dateError) ? '(Please select schedule date & time.)' : ''}</span></ControlLabel> <br/>
                  <DateTimePicker
                    // className={this.state.startPauseDateTimeError}
                    onChange={this.onChangeScheduleDateTime}
                    value={this.state.scheduleDateTime}
                    minDate={new Date()}
                  />
              </FormGroup>
              </Col>
            </Row>
          }
          <Row><hr/></Row>
          <Row>
            <Col md={12} xs={12}>
              <ControlLabel>Choose from imported List</ControlLabel>
              <table className="table table-hover table-bordered">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>File Name</th>
                    <th>Uploaded Date</th>
                  </tr>
                </thead>
                <tbody>
                    {(this.state.fileList.data) ? 
                      this.state.fileList.data.map((data, index) => 
                        <tr key={Math.random()}>
                          <td>
                          {(subscriberList.indexOf(data.fileName) > -1) ?
                            <Checkbox value={data.fileName} defaultChecked={true} onClick={this.handleSelectedFile}></Checkbox>
                          :
                            <Checkbox name={index} onClick={this.handleSelectedFile}  value={data.fileName}></Checkbox>
                          }
                          </td>
                          <td>{data.fileName}</td>
                          <td> 
                           {moment(data.created_at).format("MM-DD-YYYY HH:mm:ss")}
                          </td>
                        </tr>
                      )
                    :
                    <tr><td colSpan="6" className="text-center">Data Not Found</td></tr>
                    }
                </tbody>
              </table>
              <div className="text-center">
                <Pagination
                  total={totalRecords}
                  limit={perPage}
                  pageCount={pageCount}
                  currentPage={currentPage}
                >
                  {({
                    pages,
                    currentPage,
                    hasNextPage,
                    hasPreviousPage,
                    previousPage,
                    nextPage,
                    totalPages,
                    getPageItemProps
                  }) => (
                    <div className="pagination">
                      <button
                        {...getPageItemProps({
                          pageValue: 1,
                          onPageChange: this.handlePageChange
                        })}
                      >
                        first
                      </button>

                      {hasPreviousPage && (
                        <button
                          {...getPageItemProps({
                            pageValue: previousPage,
                            onPageChange: this.handlePageChange
                          })}
                        >
                          {'<'}
                        </button>
                      )}

                      {pages.map(page => {
                        let activePage = null;
                        if (currentPage === page) {
                          activePage = { backgroundColor: '#ccc', color: '#666' };
                        }
                        return (
                          <button
                            key={page}
                            style={activePage}
                            {...getPageItemProps({
                              pageValue: page,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            {page}
                          </button>
                        );
                      })}

                      {hasNextPage && (
                        <button
                          {...getPageItemProps({
                            pageValue: nextPage,
                            onPageChange: this.handlePageChange
                          })}
                        >
                          {'>'}
                        </button>
                      )}

                      <button
                        {...getPageItemProps({
                          pageValue: totalPages,
                          onPageChange: this.handlePageChange
                        })}
                      >
                        last
                      </button>
                    </div>
                  )}
                </Pagination>
                </div>
            </Col>
            <Col md={12} xs={12}>
              {/*Users: {this.state.user},*/}
              <a onClick={this.handleTotalUser}>Click here to display / refresh the number of Targeted Users for this blast :</a> Subscribers:{this.state.subscriber}
            </Col>
          </Row>
          <Row><hr/></Row>
          <Row>
            <Col md={12} xs={12}>
            <Button bsStyle="success" onClick={this.handlePrev}>Previous</Button>
            
              <Button bsStyle="success" className="pull-right" onClick={this.handleSubmit}>{(this.state.scheduleStatus) ? 'Save & Schedule' : 'Send Now'}</Button>
              {(!this.state.scheduleStatus) ?
                <Button bsStyle="success" className="pull-right" onClick={this.handleSchedule}>Schedule</Button>
                :
                <Button bsStyle="default" className="pull-right" onClick={this.cancelSchedule}>Cancel Schedule</Button>
              }
            </Col>
          </Row>
          </div>
      </div>
    </form>
  )
  }
}

const mapStateToProps = (state,ownProps) => {
    return {
      error: state.emailManagerReducer.error,
      cityList:  state.emailManagerReducer.cityList,
      merchantList: state.merchantReducer.merchantList,
      catList:  state.categoryReducer.catData,
      subscriberList:  state.emailManagerReducer.subscriberList,
      totalUsers: state.emailManagerReducer.totalUsers,
    };
};
export default compose(
  withRouter, 
  connect(mapStateToProps, {getCoutnryCity, get_merchant_list, getAllCategory, getSubscriberFile, getTotalSubscriber})
)(WizardFormSecondPage);


// WEBPACK FOOTER //
// ./src/app/views/admin/EmailManager/common/WizardFormSecondPage.js